var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef, useState } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { useQueryClient } from "react-query";
import { fetchCoEditionRequestById } from "../api/coEditionRequestService";
import { useDetailParam } from "../utils/detailParam";
import { CO_EDITION_REQUESTS_QUERY_KEY } from "./useCoEditionRequestsData";
export var useCoEditionRequestActions = function () {
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var kyRef = useRef(ky);
    useEffect(function () {
        kyRef.current = ky;
    }, [ky]);
    var _a = useDetailParam(), detailId = _a.detailId, updateDetailParam = _a.updateDetailParam;
    var updateDetailParamRef = useRef(updateDetailParam);
    useEffect(function () {
        updateDetailParamRef.current = updateDetailParam;
    }, [updateDetailParam]);
    var _b = useState(null), selectedRequest = _b[0], setSelectedRequest = _b[1];
    var _c = useState(null), modalMode = _c[0], setModalMode = _c[1];
    useEffect(function () {
        var abortController = new AbortController();
        if (!detailId) {
            setSelectedRequest(function (prev) { return (prev ? null : prev); });
            return undefined;
        }
        fetchCoEditionRequestById(kyRef.current, detailId)
            .then(function (request) {
            if (abortController.signal.aborted)
                return;
            setSelectedRequest(request !== null && request !== void 0 ? request : null);
        })
            .catch(function () {
            if (abortController.signal.aborted)
                return;
            setSelectedRequest(null);
            updateDetailParamRef.current(null);
        });
        return function () {
            abortController.abort();
        };
    }, [detailId]);
    var handleRowClick = function (item) {
        updateDetailParamRef.current(item.id);
        setSelectedRequest(item);
    };
    var handleCloseDetail = function () {
        setSelectedRequest(null);
        updateDetailParamRef.current(null);
    };
    var refreshDetail = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!detailId)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchCoEditionRequestById(kyRef.current, detailId)];
                case 2:
                    request = _b.sent();
                    setSelectedRequest(request !== null && request !== void 0 ? request : null);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    setSelectedRequest(null);
                    updateDetailParamRef.current(null);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var openAssignModal = function () { return setModalMode("assign"); };
    var openRejectModal = function () { return setModalMode("reject"); };
    var openConfirmConsentModal = function () { return setModalMode("confirmConsent"); };
    var closeModal = function () { return setModalMode(null); };
    var handleActionDone = function () {
        queryClient.invalidateQueries(CO_EDITION_REQUESTS_QUERY_KEY);
        refreshDetail();
        closeModal();
    };
    return {
        selectedRequest: selectedRequest,
        handleRowClick: handleRowClick,
        handleCloseDetail: handleCloseDetail,
        refreshDetail: refreshDetail,
        modalMode: modalMode,
        openAssignModal: openAssignModal,
        openRejectModal: openRejectModal,
        openConfirmConsentModal: openConfirmConsentModal,
        closeModal: closeModal,
        handleActionDone: handleActionDone,
    };
};
